import { ProductAdminDTO } from './Types/dto/admin/product'

export const missingFieldToRunEvent = (pr?: ProductAdminDTO) => {
	if (!pr) {
		return ''
	} else if (!pr?.name) {
		return 'Esemény neve'
	} else if (Object.keys(pr?.pricingOptions ?? {}).length == 0) {
		return 'Legalább egy árazási opció'
	} else if (
		Object.entries(pr?.pricingOptions ?? {}).length > 1 &&
		!pr.pricingOptionSelectTitle
	) {
		return 'Fizetési opció legördülő menü megnevezése'
	} else if (
		pr?.timeSelectionType == 'oneOrManyTime' &&
		Object.keys(pr?.eventTimes ?? {}).length == 0
	) {
		return 'Legalább egy időpont'
	}

	for (const k in pr?.pricingOptions) {
		let po = pr?.pricingOptions[k]
		for (const k2a in po.invoiceSchemaItemGroups) {
			let po2 = po?.invoiceSchemaItemGroups[k2a]
			for (const k2 in po2.invoiceSchemaItems) {
				let ii = po2.invoiceSchemaItems[k2]
				if (!ii.unitPrice) {
					return 'Ár az egyik számlatételen'
				} else if (ii.invoiceItemQuantityType == 'fix' && !ii.quantity) {
					return 'Mennyiség az egyik számlatételen'
				} else if (pr?.enableSendInvoice && !ii.unit) {
					return 'Mértékegység az egyik számlatételen'
				}
			}
		}
	}

	// TODO: Put back, but for team
	/*for (const k in pr?.formFields) {
		let ffs = pr?.formFields[k]
		if (!ffs.name) {
			return 'Megnevezés az egyik űrlap mezőn'
		}
		for (const k2 in ffs.options) {
			let o = ffs.options[k2]
			if (!o.name) {
				return 'Megnevezés az egyik űrlapmezőhöz tartozó opción'
			}
		}
	}*/
}
